import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="systems-onboarding"
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    if (window.agGrids) {
      const filter = window.location.search.replace("?status=", "")
      if (filter) { this.setFilter(filter) }
    }
  }

  filter(event) {
    let filter = event.currentTarget.dataset.filter

    if (this.visibleGrid()) {
      this.setFilter(filter)
    } else {
      window.location.href = "systems?status=" + filter
    }
  }

  setFilter(filter) {
    let model

    if (filter == "Missing") {
      model = {
        missing_info: {
          type: "set",
          values: ["true"]
        }
      }
    } else {
      model = {
        status: {
          type: "set",
          values: [filter]
        }
      }
    }

    this.visibleGrid().setFilterModel(model)
  }

  visibleGrid() {
    if (window.agGrids) {
      return window.agGrids.find(grid => grid.isVisible())
    }
  }
}
